/** @jsx jsx */
/* eslint-disable no-use-before-define, eqeqeq */
import { jsx } from '@emotion/core'
import { displayInline } from '../style.js'
import React from 'react'
import { useOrderTicket, MODES } from '../use-order-ticket.js'
import { getId, fmt, Flyout, isNumeric} from '../../twd'


export const Yield = () => {
    const {
        action, yld, setYld, priceOrYield, setPriceOrYield,
        orderInfo, hasOrderInfo, hasBondInfo,
        mode, errors, setYieldEl, isRestricted,
        bestYield,
        bondInfo,
    } = useOrderTicket()

    const s = orderInfo.statusMsg || ''
    const hasMarket = s.indexOf('NO OFFERINGS FOR TICKET') < 0
        && s.indexOf('NO ORDER CONFIGURED FOR TICKET') < 0

    const canTrade = hasBondInfo && !isRestricted
    const isLift = mode===MODES.ORDER_Z
    const isDisabled = !canTrade || !hasMarket
    const isCounterDisallowed = canTrade && (orderInfo.countersAllowed === 'N' || orderInfo.primary==='Y')
    const isReadOnly = isLift || isCounterDisallowed

    const id = getId()
    const err = !isDisabled && errors && errors.yld
    const yldLabel = action==='B' ? 'Offer' :
        action==='S' ? 'Bid' :
        ''

    return <React.Fragment>
    <div className={isReadOnly ? "" : "row"}>
    { !isReadOnly && <div className="col-md-1 col-xs-1 col-auto" style={{minWidth:'25px', maxWidth:'25px', marginTop:'20px'}}>
        <input
            type="radio"
            aria-label="Choose yield"
            name={"order-ticket-form-price-or-yield"}
            value={0}
            checked={priceOrYield===0}
            onChange={() => setPriceOrYield(0)}
            />
    </div>}

    <div className="col-md-1 col-xs-5 col-auto"
        style={{
            minWidth:'130px',
            ...(isReadOnly ? {paddingLeft:0}: {})
        }}
    >
        <div className="from-group" style={{ paddingLeft:'0px', paddingRight:'0px' }} >
        <div><Flyout
                label="Yield"
                labelAttrs={{htmlFor:id}}
                isLabel={true}
                html={YieldTooltip}
            /></div>
            <div className={err ? ' has-error' : ''}>

            {isReadOnly && <div className='input-group'>
                <label className="label text-bold">{formatYield(isCounterDisallowed ? bestYield : orderInfo.yield, bondInfo)}</label>
                </div>}

            {!isReadOnly && <input
                type="number"
                ref={setYieldEl}
                id={id}
                className='form-control'
                value={yld}
                min="0"
                step="any"
                disabled={isDisabled}
                aria-disabled={isDisabled}
                style={{paddingLeft:'20px'}}
                onChange={(e) =>{
                    setYld(e.target.value || '')
                }}
                />}
            </div>
            { err && <label className="field-status has-error">{err}</label> }
        </div>
    </div>

    { hasOrderInfo && canTrade && yldLabel && !isReadOnly &&
    <div className="col-md-5 col-xs-1 col-auto" style={{minWidth:'200px', marginTop:'20px'}}>
        <div css={displayInline}>{yldLabel} Yield: </div>
        <span className="text-bold">{formatYield(bestYield, bondInfo)}</span>
    </div>}

    </div>
    </React.Fragment>

}

const formatYield = (ytw, bondInfo) => {
    const isNoCalc = bondInfo && bondInfo.issue && ['O','K'].includes(bondInfo.issue.type)
    const a = !isNumeric(ytw) ? null
        : ytw==0.0 && isNoCalc ? null
        : ytw
    return fmt.price3N(a)
}

const YieldTooltip = `
    A bond’s yield is the expected return an investor receives from a bond over its term to maturity/redemption,
    expressed as an annual percentage of the bond’s face value. The calculation of a bond’s yield considers
    its price, coupon payments, and time remaining until maturity/redemption.
    A bond’s yield to worst is a measure of the lowest possible expected return an investor can receive on
    a bond – assuming no default event. If the yield value displayed on your ticket is not firm,
    a custom limit yield can be entered in attempt to trade the bond at an improved price than the current best offer.
    Limit price orders may be rejected by the dealer.
`
